export default __webpack_public_path__ + "static/media/children.18a7a058.pdf";